import SvgIcon from 'common/components/svg-icon';


const FacebookIcon = (props) => (
    <SvgIcon { ...props }>
        <path
            d='M25.76,46.32h6.74V30H37l.6-5.62h-5.1V21.56c0-1.47.14-2.25,2.24-2.25h2.81V13.68h-4.5c-5.41,0-7.31,2.73-7.31,7.32v3.38H22.4V30h3.37ZM0,0H60V60H0Z'
            />
    </SvgIcon>
);


export default FacebookIcon;



// WEBPACK FOOTER //
// ./src/common/components/svg-icon/facebook.js